module.exports = __webpack_public_path__ + "img/docker.39d77695.svg";